import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import type { RootState } from '../store/redux/store/store';
import { resolveCompanyClock, type CompanyClock } from '../utils/companyClock';

/**
 * The logged-in user's COMPANY wall clock, straight out of state — no request.
 *
 * `state.user.company.timeZone` is part of the bootstrap payload (`GetUserInfo` → `UserCompanyView`) and
 * the server normalises it to an IANA id on the way out, so this never needs a `GET Company/{id}` and
 * never sees a Windows id. See `utils/companyClock` for the fallback chain and why it lands on UTC rather
 * than the browser.
 */
export const useCompanyClock = (): CompanyClock => {
  const companyTimeZone = useSelector((s: RootState) => s.user.company?.timeZone);
  return useMemo(() => resolveCompanyClock(companyTimeZone), [companyTimeZone]);
};

/** Convenience for call sites that only want the IANA id. */
export const useCompanyTimeZone = (): string => useCompanyClock().timeZone;
